import { AlertSeverity } from '@aloft/toolkit-shared';
import { Icon, colors } from '@aloft/toolkit-sui';

const iconStyle = { flexShrink: 0, display: 'block' } as const;

const ERROR_PATH =
  'M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0ZM14.4443 5.55566C14.1376 5.24892 13.6408 5.24898 13.334 5.55566L10 8.88867L6.66602 5.55566C6.35923 5.24898 5.86241 5.24892 5.55566 5.55566C5.24892 5.86241 5.24898 6.35923 5.55566 6.66602L8.88867 10L5.55566 13.334C5.24898 13.6408 5.24892 14.1376 5.55566 14.4443C5.86241 14.7511 6.35923 14.751 6.66602 14.4443L10 11.1113L13.334 14.4443C13.6408 14.751 14.1376 14.7511 14.4443 14.4443C14.7511 14.1376 14.751 13.6408 14.4443 13.334L11.1113 10L14.4443 6.66602C14.751 6.35923 14.7511 5.86241 14.4443 5.55566Z';

const WARNING_PATH =
  'M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0ZM9.16309 14.1406V15.8076H10.8291V14.1406H9.16309ZM9.16309 4.14062V11.6406H10.8291V4.14062H9.16309Z';

export const AlertSeverityIcon = ({
  severity,
  variant = 'severity',
}: {
  severity: AlertSeverity;
  variant?: 'severity' | 'ai';
}) =>
  variant === 'ai' ? (
    <Icon icon="sparkle" size="md" color="alertAiIcon" __styleDoNotUse={iconStyle} />
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 20 20"
      fill="none"
      style={iconStyle}
      aria-hidden
    >
      <path
        d={severity === 'error' ? ERROR_PATH : WARNING_PATH}
        fill={severity === 'error' ? colors.alertError : colors.graphChart4}
      />
    </svg>
  );
